<template>
  <div class="main-container" v-redirect-if-no-permission:CREATE_BOOKING>
    <div class="elements-container" style="max-width: 50%">
      <div class="order-form shadow">
        <div class="form">
          <div>
            <h1>{{ $t("createBookingPage.newOrder") }}</h1>
            <h2>{{ $t("createBookingPage.newOrderSubtitle") }}</h2>
          </div>
          <div class="input">
            <label :class="[modelErrors.passenger_name && 'text-red']">{{ $t("createBookingPage.passengerName") }}
              <span v-if="modelErrors.passenger_name">{{ $t("createBookingPage.passengerNameError") }}</span></label>
            <input name="passenger_name" type="text" autocomplete="off" v-model="model.passenger_name"
              @blur="validateAt(['passenger_name'])" :class="[modelErrors.passenger_name && 'border-red']"
              :placeholder="$t('createBookingPage.passengerName')" />
          </div>
          <div class="input">
            <label :class="[modelErrors.passenger_phone_number && 'text-red']">{{ $t("createBookingPage.passengerPhone") }}
              <span v-if="modelErrors.passenger_phone_number">{{ $t("createBookingPage.passengerPhoneError") }}</span></label>
            <input name="passenger_phone_number" type="text" autocomplete="off" v-model="model.passenger_phone_number"
              @blur="validateAt(['passenger_phone_number'])"
              :class="[modelErrors.passenger_phone_number && 'border-red']" :placeholder="$t('createBookingPage.passengerPhone')" />
          </div>
          <div class="input">
            <label :class="[modelErrors.passenger_email && 'text-red']">{{ $t("createBookingPage.passengerEmail") }}
              <span v-if="modelErrors.passenger_email">{{ $t("createBookingPage.passengerEmailError") }}</span></label>
            <input name="passenger_email" type="text" autocomplete="off" v-model="model.passenger_email"
              @blur="validateAt(['passenger_email'])" :class="[modelErrors.passenger_email && 'border-red']"
              :placeholder="$t('createBookingPage.passengerEmail')" />
          </div>
          <div class="input">
            <label class="text-gray">{{ $t("createBookingPage.timeDate") }}</label>
            <TimeSelectInput @input="selectedTime = $event" :value="selectedTime" />
          </div>
          <div class="input">
            <label :class="[modelErrors.pick_up_location_id && 'text-red']">{{ $t("createBookingPage.pickup") }}
              <span v-if="modelErrors.pick_up_location_id">{{ $t("createBookingPage.pickupError") }}</span></label>
            <GoogleMapsInput class="w-full" :placeholder="$t('createBookingPage.selectPickup')" :error="modelErrors.pick_up_location_id"
              @inputSelected="pick_up_location_obj = $event" @validate="validateAt(['pick_up_location_id'])"
              :value="pick_up_location_obj" />
          </div>
          <div class="input">
            <label :class="[modelErrors.pull_down_location_id && 'text-red']">{{ $t("createBookingPage.destination") }}
              <span v-if="modelErrors.pull_down_location_id">{{ $t("createBookingPage.destinationError") }}</span></label>
            <GoogleMapsInput class="w-full" :placeholder="$t('createBookingPage.destination')" :error="modelErrors.pull_down_location_id"
              @inputSelected="pull_down_location_obj = $event" @validate="validateAt(['pull_down_location_id'])"
              :value="pull_down_location_obj" />
          </div>

          <div class="input">
            <label class="text-gray">{{ $t("createBookingPage.voucherCode") }}</label>
            <input name="voucher" type="text" autocomplete="off" v-model="model.voucher" :placeholder="$t('createBookingPage.voucherCode')" />
          </div>

          <div class="input">
            <label class="text-gray">{{ $t("createBookingPage.specificDriver") }}</label>
            <v-autocomplete
              v-model="model.target_captain_id"
              :items="targetCaptains"
              :loading="captainLoading"
              :search-input.sync="captainSearch"
              clearable
              item-value="id"
              item-text="text"
              :placeholder="$t('createBookingPage.specificDriverPlaceholder')"
              hide-details
              cache-items
            >
              <template slot="item" slot-scope="data">
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.text"></v-list-tile-title>
                </v-list-tile-content>
              </template>
            </v-autocomplete>
          </div>
          <br />
          <div style="width:30%" class="float-left input">
            <div class="spring-spinner"  v-if="servicesLoading">
              <div class="spring-spinner-part top">
                <div class="spring-spinner-rotator"></div>
              </div>
              <div class="spring-spinner-part bottom">
                <div class="spring-spinner-rotator"></div>
              </div>
            </div>
          </div>

          <div v-show="services.length > 0 && !servicesLoading" class="input">
            <label :class="[modelErrors.service_id && 'text-red']">{{ $t("createBookingPage.services") }}
              <span v-if="modelErrors.service_id">{{ $t("createBookingPage.serviceError") }}</span></label>
            <RadioGroup :options="services" :value="selectedServiceObj" @input="selectedServiceObj = $event" />
          </div>


          <div v-if="selectedServiceObj && services.length > 0 && !servicesLoading"
            class="w-full float-left estimation">
            <label class="text-gray">
              <p>{{ $t("createBookingPage.estimatedPrice") }} : <span class="old-price"
                  v-if="selectedServiceObj.estimated_price != selectedServiceObj.to_pay">{{
                    selectedServiceObj.estimated_price | money
                  }}</span> <span>{{ selectedServiceObj.to_pay | money }}</span></p>
            </label>

          </div>

          <div class="w-full float-left">
            <button class="btn" @click="sendRequest" :disabled="sendingRequest">
              {{ sendingRequest ? $t("createBookingPage.loading") : $t("createBookingPage.send") }}
            </button>

          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import SelectInput from "@/components/widgets/SelectInput.vue";
import TimeSelectInput from "@/components/widgets/TimeSelectInput.vue";
import RadioGroup from "@/components/widgets/RadioGroup.vue";
import CheckBoxesGroup from "@/components/widgets/CheckBoxesGroup";
import GoogleMapsInput from "@/components/widgets/GoogleMapsInput.vue";

import * as yup from "yup";
import * as gjv from "geojson-validation";
import axios from "axios";
import moment from "moment";
let CancelToken = axios.CancelToken;
var cancelRequest;

const modelSchema = yup.object().shape({
  service_id: yup.number().required(),
  pull_down_location_id: yup.number().required(),
  pick_up_location_id: yup.number().required(),
  passenger_name: yup.string().required(),
  passenger_phone_number: yup.number().required(),
  passenger_email: yup.string().email(),

});

export default {
  name: "CreateBooking",
  title() {
    return this.$t("createBookingPage.pageTitle");
  },

  components: {
    SelectInput,
    TimeSelectInput,
    RadioGroup,
    CheckBoxesGroup,
    GoogleMapsInput,
  },
  data() {
    return {
      pick_up_location_obj: null,
      pull_down_location_obj: null,
      lastOrderError: null,
      dynamicConstraints: [],
      services: [],
      servicesLoading: false,
      model: {

        service_id: null,
        pick_up_location_id: null,
        pull_down_location_id: null,
        datetime: "ASAP",
        voucher: "",
        passenger_name: "",
        passenger_phone_number: "",
        passenger_email: "",
        target_captain_id: null,
      },
      targetCaptains: [],
      captainSearch: null,
      captainLoading: false,
      quoteDebounceTimer: null,
      modelErrors: {
        service_id: false,
        pick_up_location_id: false,
        pull_down_location_id: false,
        passenger_name: false,
        passenger_phone_number: false,
        passenger_email: false
      },
      errors: {
        multipleOrders: false,
      },
      multipleOrders: false,
      multipleOrdersCount: 2,
      selectedTime: "ASAP",
      cities: [],
      selectedCity: {
        centroid: {},
      },
      cars: [],

      langs: [],
      selectedCar: null,
      selectedServiceObj: null,
      selectedCarObj: {},
      constraints: [],
      show_label: true,
      selectedConstraints: [],
      paymentMethods: [],
      selectedPaymentMethod: "",
      sendingRequest: false,
      allPendingBookings: 0,
      passengerPendingBookings: 0
    };
  },


  beforeDestroy() {
    // A pending debounced quote (or in-flight request) must not fire toasts
    // or mutate state after the operator leaves the page.
    if (this.quoteDebounceTimer) clearTimeout(this.quoteDebounceTimer);
    if (cancelRequest) cancelRequest();
  },
  methods: {
    searchCaptains(searchVal) {
      this.captainLoading = true;
      const params = new URLSearchParams();
      if (searchVal) params.append("search", searchVal);
      this.axios
        .get("captain/search", { params })
        .then((res) => {
          // `cache-items` keeps the selected driver rendered after the list is
          // replaced by a new search, so no guard/merge is needed.
          this.targetCaptains = (res.data.data || []).map((item) => ({
            id: item.id,
            text: `${item.first_name || ""} ${item.last_name || ""} (${item.username || ""})`,
            ...item,
          }));
        })
        .catch(() => {})
        .finally(() => (this.captainLoading = false));
    },
    // Typed fields (voucher, phone) re-quote through this instead of calling
    // loadServices directly: one request after the operator pauses, instead of
    // one 400-"invalid code" toast + services-list teardown per keystroke.
    debouncedLoadServices() {
      if (this.quoteDebounceTimer) clearTimeout(this.quoteDebounceTimer);
      this.quoteDebounceTimer = setTimeout(() => {
        this.quoteDebounceTimer = null;
        this.loadServices();
      }, 500);
    },
    validateAt(keys) {
      keys.forEach((key) => {
        if (key in this.modelErrors) {
          modelSchema
            .validateAt(key, this.model)
            .then(() => {
              this.modelErrors[key] = false;
            })
            .catch(() => {
              this.modelErrors[key] = true;
            });
        }
      });
    },
    validate(field) {
      if (field in this.model) {
        modelSchema
          .validateAt(field, this.model)
          .then(() => {
            this.modelErrors[field] = false;
          })
          .catch(() => {
            this.modelErrors[field] = true;
          });
      }
    },


    fixScroll(n, count = 0, changeBy = 1) {
      let target =
        target > scrollLeft
          ? document.getElementById(`${n}`).offsetLeft + 12
          : document.getElementById(`${n}`).offsetLeft - 12;
      // let target = document.getElementById(`${n}`).offsetLeft;
      let scrollLeft = this.$refs.counts.scrollLeft;
      this.$refs.counts.scrollLeft =
        target > scrollLeft ? scrollLeft + changeBy : scrollLeft - changeBy;
      let diff = Math.floor(Math.abs(this.$refs.counts.scrollLeft - target));
      if (count < diff) {
        window.requestAnimationFrame(() => {
          this.fixScroll(n, count + 1, count + 1);
        });
      }
    },



    loadServices() {
      if (!this.model.pick_up_location_id || !this.model.pull_down_location_id) {
        return;
      }

      let data = {
        "pickup": this.model.pick_up_location_id,
        "destination": this.model.pull_down_location_id,

      };
      if (this.model.voucher)
        data.voucher = this.model.voucher;
      // The backend validates the voucher against the real customer account
      // matched by this phone (dedicated codes + one-use-per-rider); without
      // it, codes are checked against the shared call-center passenger.
      if (this.model.passenger_phone_number)
        data.phone = String(this.model.passenger_phone_number);
      if (this.model.datetime != "ASAP")
        data.time = this.model.datetime;
      this.servicesLoading = true;

      if (cancelRequest) cancelRequest();
      let cancelled = false;
      axios
        .post("booking-services", data,
          {
            cancelToken: new CancelToken(function executor(c) {
              cancelRequest = c;
            }),
          })
        .then((response) => {
          this.services = [];

          response.data.data.services.forEach((item) => {
            this.services.push({
              id: item.id,
              title: item.name_en,
              img: item.icon,
              estimated_price: item.estimated_price,
              to_pay: item.to_pay,
              discounted_amount: item.discounted_amount
            });

          });



          if (this.services.length > 0) {

            this.selectedServiceObj = this.services[0];
          }

        })
        .catch((error) => {
          // A request superseded by a newer keystroke lands here as a Cancel
          // with no `response`; reading response.data blindly threw and left
          // stale services/spinner state behind.
          if (axios.isCancel(error)) {
            cancelled = true;
            return;
          }
          console.log(error);
          const message = error.response && error.response.data && error.response.data.message;
          window.getApp.$emit("SHOW_TOAST", message || this.$t("createBookingPage.cantLoadServices"), "red");

          this.services = [];
          this.selectedServiceObj = null;
        })
        .finally(() => {
          // The newer in-flight request owns the spinner now.
          if (!cancelled) this.servicesLoading = false;
        });

    },


    buildPayload() {
      // Build the POST body from a COPY so we never mutate (and thereby break
      // the Vue reactivity of) the bound form model. Optional empty fields are
      // omitted; the model itself keeps all of its reactive keys intact.
      const payload = { ...this.model };
      if (payload.datetime === "ASAP") delete payload.datetime;
      if (!payload.voucher) delete payload.voucher;
      if (!payload.passenger_email) delete payload.passenger_email;
      if (!payload.target_captain_id) delete payload.target_captain_id;
      return payload;
    },

    async sendRequest() {
      const payload = this.buildPayload();

      modelSchema
        .validate(this.model)
        .then(() => {
          this.sendingRequest = true;
          this.axios
            .post("booking", payload)
            .then(() => {
              window.getApp.$emit("SHOW_TOAST", this.$t("createBookingPage.savedSuccessfully"), "green");
              this.services = [];
              this.pick_up_location_obj = null;
              this.pull_down_location_obj = null;
              this.selectedTime = "ASAP";

              this.selectedServiceObj = null;

              this.model.service_id = null;
              this.model.voucher = "";
              this.model.passenger_email = "";
              this.model.passenger_name = "";
              this.model.passenger_phone_number = "";

              // Reset the optional driver picker for the next booking.
              this.model.target_captain_id = null;
              this.captainSearch = null;
              this.targetCaptains = [];


            })
            .catch((err) => {
              const message = err.response && err.response.data && err.response.data.message;
              window.getApp.$emit("SHOW_TOAST", message || this.$t("createBookingPage.errorOccurred"), "red");
            })
            .finally(() => {
              this.sendingRequest = false;
              window.scrollTo(0, 0);
            });
        })
        .catch(() => {
          window.scrollTo(0, 0);
          Object.keys(this.model).forEach((key) => {
            if (key in this.modelErrors) {
              modelSchema
                .validateAt(key, this.model)
                .then(() => {
                  this.modelErrors[key] = false;
                })
                .catch(() => {
                  console.log("VALIDATION ERROR AT ", key);
                  this.modelErrors[key] = true;
                });
            }
          });
        });

    },
  },
  watch: {

    pick_up_location_obj: function (newVal) {
      if (newVal)
        this.model.pick_up_location_id = newVal.id;
      else
        this.model.pick_up_location_id = null;
      this.loadServices()
    },
    pull_down_location_obj: function (newVal) {
      if (newVal)
        this.model.pull_down_location_id = newVal.id;
      else
        this.model.pull_down_location_id = null;
      this.loadServices()
    },
    "model.voucher": function (newVal) {
      this.debouncedLoadServices()
    },
    // The voucher is validated against the account matched by this phone, so
    // a phone typed AFTER the code must re-run the quote. Skip when no code
    // is entered - the phone alone does not change prices.
    "model.passenger_phone_number": function () {
      if (this.model.voucher) this.debouncedLoadServices()
    },
    captainSearch: function (val) {
      if (val === null) return;
      this.searchCaptains(val);
    },
    selectedServiceObj: function (newVal) {
      if (newVal && newVal.id)
        this.model.service_id = newVal.id;
      else
        this.model.service_id = null;
    },
    selectedTime: function (newVal) {
      if (newVal !== "ASAP")
        this.model.datetime = this.model.datetime = moment(
                                    this.selectedTime,
                                    "DD-MM-YYYY HH:mm",
                                    true 
                                  ).format("YYYY-MM-DD HH:mm");
      else
        this.model.datetime = "ASAP";
      this.loadServices()
    },

  },
};
</script>

<style lang="scss" scoped>
input {
  width: 100%;
  max-width: 400px;
  padding: 16px 15px;
  font-size: 14px;
  border-radius: 10px;
  border: 1px solid #c1c5d8;
  background-color: #f7f8fa;
  float: inline-start;
  color: #202731;
}

input:focus {
  border-color: #202731;
  outline: none;
}

form {
  span {
    width: 100%;
    float: inline-start;
    max-width: 400px;
    text-align: start;
    color: #e10015;
    font-size: 14px;
    padding-bottom: 2px;
  }
}

input::placeholder {
  color: #788e98;
  opacity: 1;
  /* Firefox */
}

input::-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #788e98;
}

input::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #788e98;
}

button {
  width: 100%;
  max-width: 160px;
  float: inline-end;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: #e10015;
  color: white;
  font-size: 14px;
  border-radius: 4px;
  transition: 0.1s;
  margin-top: 48px;
}

button:active {
  transform: scale(0.98);
}

.shadow {
  box-shadow: 0 0 6px rgba(0, 11, 138, 0.12) !important;
}

.input {
  label:first-child {
    text-align: start;
    float: inline-start;
    font-size: 14px;
    padding-bottom: 6px;
    width: 100%;
    color: #788e98;

    span {
      float: inline-end;
      text-align: end;
      color: red;
    }
  }

  input {
    float: inline-start;
    width: 100%;
    max-width: none;
  }

  .check-box {
    float: inline-start;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    input {
      width: 14px;
      height: 14px;
      float: inline-start;
    }

    label {
      margin-inline-start: 4px;
    }
  }
}

.main-container {
  float: inline-start;
  width: 100%;
  padding: 2rem 9rem;
  display: flex;
  justify-content: center;
  align-items: center;

  .elements-container {
    display: flex;
    float: inline-start;
    flex-direction: row;
    width: 100%;
    gap: 3.5rem;

    .order-form {
      float: inline-start;
      padding-top: 2.25rem;
      padding-bottom: 2.25rem;
      padding-inline-start: 2.5rem;
      padding-inline-end: 2.5rem;
      flex-grow: 1;
      width: 60%;
      border-radius: 0.5rem;

      .form {
        display: flex;
        float: inline-start;
        flex-direction: column;
        width: 100%;
        gap: 1.5rem;

        div {
          width: 100%;
          float: inline-start;

          &:first-child {
            h1 {
              color: #202731;
              font-size: 1.125rem;
              line-height: 1.75rem;
              font-weight: 500;
              text-align: start;
            }

            h2 {
              font-weight: 400 !important;
              font-size: 1rem;
              line-height: 1.25rem;
              text-align: start;
              color: #788e98;
            }
          }
        }
      }
    }
  }
}

.text-red {
  color: red !important;
}

// The pre-discount price shown beside the discounted one. Without the
// strikethrough, a large FIXED voucher rendered as two bare numbers
// ("200.00 0.00") that read as corrupted pricing.
.old-price {
  text-decoration: line-through;
  opacity: 0.6;
  margin-inline-end: 6px;
}

.border-red {
  border: 1px solid red !important;
}

// bg-white
// shadow
// rounded-lg
// flex-grow
// h-auto
// pt-6
// pb-0
// px-4
// sticky
// top-8

.right-bar {
  width: 400px;
  position: sticky;
  top: 92px;
  height: calc(100vh - 120px);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 1;
  gap: 1.5rem;
  padding-bottom: 1.5rem;

  .client-orders {
    width: 100%;
    padding-inline-start: 1rem;
    padding-inline-end: 1rem;
    padding-bottom: 0;
    padding-top: 1.5rem;
    background-color: #ffffff;
    height: auto;
    flex-grow: 1;
    flex-shrink: 1;
    border-radius: 0.5rem;
    float: inline-start;
  }

  .drivers-count {
    width: 100%;
    padding: 1rem;
    background: #fff;
    height: 12.5rem;
    flex-grow: 0;
    flex-shrink: 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: row;
    border-radius: 0.5rem;
    float: inline-start;
    overflow-x: overlay;
    gap: 12px;
    position: relative;

    .message {
      width: 100%;
      height: 100%;
      float: inline-start;
      display: flex;
      justify-content: center;
      align-items: center;
      color: red;
      position: absolute;
      top: 0;
      inset-inline-start: 0;
    }

    &::-webkit-scrollbar {
      height: 0px;
    }

    .item {
      height: 100%;
      border-radius: 0.5rem;
      position: relative;
      background: white;
      float: inline-start;
      width: 70px;
      overflow: hidden;
      cursor: pointer;
      transition: 0.4s;
      flex-grow: 0;
      flex-shrink: 0;

      &.zero-width {
        width: 0px;
      }

      &.hidden {
        display: none;
      }

      &:hover {
        width: 230px;

        .item-container {
          .item-content:first-child {
            background-color: #f3f3f3;
          }
        }
      }

      .vehicle-counts {
        float: inline-start;
        height: 100%;
        padding: 6px;
        display: grid;
        grid-template-columns: 50% 50%;
        grid-template-rows: 33.3% 33.3% 33.3%;
        width: 160px;
        cursor: default;
        background: white;

        div {
          padding: 4px;
          overflow: hidden;
          width: 100%;

          label:first-child {
            font-weight: 600;
          }

          label {
            width: 100%;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }

      .item-container {
        position: absolute;
        inset-inline-start: 0;
        top: 0;
        float: inline-start;
        display: flex;
        justify-content: flex-start;
        height: 100%;

        .item-content {
          float: inline-start;
          height: 100%;
          padding: 24px;
          width: 70px;
          text-align: center;
          background: white;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 4px;
          flex-direction: column;
          transition: 0.2s;

          h2 {
            font-size: 12pt;
            line-height: 16pt;
            max-width: 100%;
            // word-break: break-word;
          }

          label {
            font-size: 18pt;
            line-height: 24pt;
            max-width: 100%;
          }
        }
      }
    }
  }
}


.spring-spinner,
.spring-spinner * {
  box-sizing: border-box;
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                    supported by Chrome, Edge, Opera and Firefox */
}


.spring-spinner {
  height: 100%;
  max-height: 30px;
  width: auto;
  max-width: 30px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: auto;
  position: relative;
}

.spring-spinner .spring-spinner-part {
  overflow: hidden;
  max-height: 15px;
  height: 100%;
  width: auto;
  max-width: 30px;
}

.spring-spinner .spring-spinner-part.bottom {
  transform: rotate(180deg) scale(-1, 1);
}

.spring-spinner .spring-spinner-rotator {
  width: 30px;
  height: 30px;
  border: 2.5px solid transparent;
  border-inline-end-color: white;
  border-top-color: #d9d9d9;
  border-radius: 50%;
  box-sizing: border-box;
  animation: spring-spinner-animation 3s ease-in-out infinite;
  transform: rotate(-200deg);
}

@keyframes spring-spinner-animation {
  50% {
    transform: rotate(115deg);
  }
}
.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
            supported by Chrome, Edge, Opera and Firefox */
}
</style>
